import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AdsStudioDisplayColorPicker } from '@bingads-webui-campaign-react/display-ads-editor';
import { mergeClasses } from '@fluentui/react-components';
import { useStyles } from './style';
import { ColorTypeEnum } from '../../util';

export const ColorEditor = ({
  i18n,
  isLoading,
  onPalettesUpdated,
  brandKit,
  paletteData,
  palettesState,
}) => {
  const classes = useStyles();
  const backgroundPalette = useMemo(() => (paletteData && paletteData.length &&
    paletteData.filter(color =>
      color.Name === ColorTypeEnum.BackgroundColor || color.isBrandKitColor)) || [], [paletteData]);
  const textPalette = useMemo(() => (paletteData && paletteData.length &&
    paletteData.filter(color =>
      color.Name === ColorTypeEnum.TextColor || color.isBrandKitColor)) || [], [paletteData]);

  const selectedColor = useCallback((colorType) => {
    const color = palettesState && palettesState.updating && palettesState.updating.find(c => c.Name === colorType);
    return color ? color.HexCode : '';
  }, [palettesState]);
  const maxColors = useMemo(() => (brandKit && brandKit.palettes && brandKit.palettes.length + 1) || 1, [brandKit]);

  const onDeleteColor = useCallback((ev, type) => {
    const { colorid } = ev.currentTarget.dataset;
    let data = Array.from((paletteData || []));
    data = data.filter(color => color.Name !== colorid);
    if (data.length > 0 && data[0].HexCode) {
      onPalettesUpdated((data[0]).HexCode, type);
    }
  }, [onPalettesUpdated, paletteData]);

  const onUpdate = colorType => (color, colorObj) => {
    onPalettesUpdated(colorObj.str, colorType);
  };

  return (
    <div>
      <div className={mergeClasses(classes.colorPalettes, 'color-palettes-background')}>
        <AdsStudioDisplayColorPicker
          i18n={i18n}
          maxColors={maxColors}
          color={selectedColor(ColorTypeEnum.BackgroundColor)}
          paletteData={backgroundPalette}
          isLoading={isLoading}
          onUpdate={onUpdate(ColorTypeEnum.BackgroundColor)}
          title={i18n.getString(_TL_('Background color'))}
          onDelete={ev => onDeleteColor(ev, ColorTypeEnum.BackgroundColor)}
          helpTopic="pop_BA_VideoTemplates_BackgroundColor"
          helpLabel="Learn more about background colors"
        />
      </div>
      <div className={mergeClasses(classes.colorPalettes, 'color-palettes-text')}>
        <AdsStudioDisplayColorPicker
          i18n={i18n}
          maxColors={maxColors}
          color={selectedColor(ColorTypeEnum.TextColor)}
          paletteData={textPalette}
          isLoading={isLoading}
          onUpdate={onUpdate(ColorTypeEnum.TextColor)}
          title={i18n.getString(_TL_('Font color'))}
          onDelete={ev => onDeleteColor(ev, ColorTypeEnum.TextColor)}
          helpTopic="pop_BA_VideoTemplates_TextColor"
          helpLabel="Learn more about font colors"
        />
      </div>
    </div>
  );
};

ColorEditor.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isLoading: PropTypes.bool,
  palettesState: PropTypes.shape({
    updating: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  onPalettesUpdated: PropTypes.func.isRequired,
  brandKit: PropTypes.shape({
    palettes: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  paletteData: PropTypes.arrayOf(PropTypes.shape({
    Name: PropTypes.string,
    HexCode: PropTypes.string,
    isBrandKitColor: PropTypes.bool,
  })).isRequired,
};

ColorEditor.defaultProps = {
  isLoading: false,
};

